export class LevelSecond {
  level2: string;
  description: string;
  visible: boolean;
}
